export enum KsefReceivingErrorReason {
    Unexpected = 'Unexpected',
    LackOfPermissions = 'LackOfPermissions',
    InsufficientWalletUnits = 'InsufficientWalletUnits'
}
